import React from 'react';
import Button from '@material-ui/core/Button';
import Loading from 'components/pure/utils/Loading';
import DepartmentProfileList from './DepartmentProfileList';
import ArchivingProfilesPageHelp from './ArchivingProfilesPageHelp';
import {Link} from 'react-router';

export default class ArchivingProfilesPage extends React.PureComponent {
  render() {
    const {wasError, isLoading, archivingProfiles} = this.props.ArchivingProfileStore;
    const {department, isDepartmentSaving} = this.props.DepartmentFormStore;
    return (
      <div className="archiving-profiles-page">
        <h1>Archiving Profiles</h1>
        <ArchivingProfilesPageHelp
          department={department}
          hasDepartmentContext={this.props.hasDepartmentContext}
          archivingProfiles={archivingProfiles}
        />
        <p>
          Create an archiving profile and assign it to one or more of your departments to control
          how long your calls can remain available in Coach.
        </p>
        <div className="button-container">
          <Button
            component={Link}
            variant="contained"
            color="primary"
            className="ev-button"
            to={window.location.pathname + '/new'}>
            New Archiving Profile
          </Button>
        </div>
        {wasError ? (
          'Error fetching profiles.'
        ) : isLoading ? (
          <Loading />
        ) : (
          <DepartmentProfileList
            isDepartmentSaving={isDepartmentSaving}
            profiles={archivingProfiles}
            hasDepartmentContext={this.props.hasDepartmentContext}
            department={department}
            updateDepartment={this.props.DepartmentActions.updateDepartment}
            profileIdName="archivingProfileId"
          />
        )}
      </div>
    );
  }
}
